import { cn } from '@askable/ui/lib/utils';

import type { ReactNode } from 'react';

type InfoAlertProps = {
  description?: string;
  title?: string;
  icon?: ReactNode;
  centerAlign?: boolean;
  children?: ReactNode;
  width?: 'full' | 'fit';
  variant?: 'default' | 'info' | 'warning';
};

const IconWrapper = ({ children }: { children: ReactNode }) => <div className="scale-x-100 transform">{children}</div>;

export const InfoAlert = ({
  description,
  title,
  icon,
  centerAlign = false,
  children,
  width = 'fit',
  variant = 'default',
}: InfoAlertProps) => {
  return (
    <div
      className={cn('flex gap-2 text-pretty rounded-lg border-0 p-4', {
        'bg-background-subtle': variant === 'default',
        'bg-info-foreground': variant === 'info',
        'bg-warning/10': variant === 'warning',
        'w-full': width === 'full',
        'w-fit': width === 'fit',
      })}
    >
      <div className={cn('flex', { 'items-center': centerAlign, 'gap-3': !!icon })}>
        <IconWrapper>{icon}</IconWrapper>
        <div className="flex flex-col gap-1">
          {title && <div className="text-sm font-semibold leading-tight">{title}</div>}
          {description && <div className="text-pretty text-sm">{description}</div>}
          {children}
        </div>
      </div>
    </div>
  );
};
